import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/project-progress-filter';

Component('tr-project-progress-filter', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,
    groupBy: String,
  },

  ready() {
    this.listenTo(this, 'tr-selector-field:change', this.handleChange.bind(this));
  },

  handleChange(event) {
    if (closest(event.target, '.group-selector')) {
      this.groupBy = event.detail;
      this.request({ group_by: event.detail });
    }
  },

  request(params = {}) {
    $.ajax({
      url: this.url,
      type: 'get',
      data: params,
      dataType: 'script',
    });
  },

  disconnected() {
    this.stopListening();
  },
});
